// extracted by mini-css-extract-plugin
export default {"headerSolicitudes":"TablaProducto_headerSolicitudes__hpzZ3","text_danger":"TablaProducto_text_danger__Se00i","text_success":"TablaProducto_text_success__pnMFR"};